import React from "react";
import { useCommunities } from "@piiqtechnologies/ui-lib";
import { Table } from "@components/common/table/Table";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { CommunitiesTableConfig, sortPredicate } from "./CommunitiesTableConfig";
import CommunitiesActions from "./communities-table-actions/CommunitiesActions";
import { PeekChip } from "@piiqtechnologies/ui-components";
export const CommunitiesTable = ({ onEdit, search }) => {
    const intl = useIntl();
    const communitiesApi = useCommunities();
    const { communitiesColumns, communityRowTransform, communitiesParams } = CommunitiesTableConfig({
        debouncedSearchKey: search,
    });
    return (React.createElement(Table, { api: communitiesApi, apiConfig: {
            params: communitiesParams,
            serverSidePagination: false,
            serverSideSorting: false,
        }, columns: communitiesColumns, rowTransform: communityRowTransform, actionsCover: (row) => [
            !row.isActive ? (React.createElement(PeekChip, { key: row._id, variant: "outlined", label: intl.formatMessage(messages.inactiveCommunity), color: "error" })) : (React.createElement(React.Fragment, null)),
        ], actions: (row) => CommunitiesActions({ onEdit: () => onEdit(row) }), notFoundMessage: intl.formatMessage(messages.noCommunities), sortPredicate: sortPredicate }));
};
export default CommunitiesTable;
